import { Action, Store } from '@ngrx/store';
import { NgrxStore } from '../decorators.module';

export function Dispatch() {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value as Function;

    if (typeof originalMethod !== 'function') {
      throw new TypeError(
        `Unexpected type ${typeof originalMethod} of property ${propertyKey}, ` +
        `expected 'function'`
      );
    }

    descriptor.value = function (...args: any[]) {
      const source$ = NgrxStore.store;
      if (source$ === null) {
        throw new Error(`${NgrxStore.name} not connected to store!`);
      }
      const actions = originalMethod.apply(this, args);

      if (Array.isArray(actions)) {
        dispatch(source$, actions);
      } else {
        dispatch(source$, [actions]);
      }
      return actions;
    };

    return descriptor;
  };
}

function dispatch<T extends Action = Action>(source$: Store<any>, actions: T[]) {
  actions.forEach(action => {
    if (typeof action !== 'object' || (typeof action === 'object' && !('type' in action))) {
      return; //can't be dispatch
    }
    source$.dispatch(action as Action);
  });
}
